import React from "react";
import ProductTemplate from "../ProductTemplate";
import m7Cover from "../../assets/m7/M7Cover.png";
import m7a from "../../assets/m7/m7a.webp";
import m7c from "../../assets/m7/m7c.webp";
import m7sec1 from "../../assets/m7/m7sec1.webp";
import m7sec2 from "../../assets/m7/m7sec2.webp";
import m7sec3 from "../../assets/m7/m7sec3.webp";
import m7sec4 from "../../assets/m7/M7SectionClose.png";
import m7sec5 from "../../assets/m7/m7sec5.webp";
import m7sec6 from "../../assets/m7/m7sec6.webp";

const M7 = () => {
  const data = {
    title: "ALUMIL M7",
    subtitle: "High-performance Curtain Wall system SMARTIA M7",
    description:
      "SMARTIA M7 is a complete system for high energy efficiency curtain walls, which offers quality constructions at affordable prices and fully meets all stability and safety requirements.",
    specifications: [
      { label: "EXTERIOR VISIBLE WIDTH", value: "50 mm" },
      { label: "MULLION DEPTH", value: "28-250 mm" },
      { label: "U-VALUE", value: "from 0.8 up to 2.3 W/m²K" },
      { label: "TRANSOM DEPTH", value: "16.5 to 257.5 mm" },
      { label: "WATER TIGHTNESS", value: "RE 1200" },
      { label: "AIR PERMEABILITY", value: "CLASS AE" },
    ],
    renders: [m7Cover, m7a, m7c],
    typologies: [], // No typologies provided
    sections: [m7sec1, m7sec2, m7sec3, m7sec4, m7sec5, m7sec6],
    relatedFiles: [
      {
        label: "SMARTIA Aluminum Systems",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/general/smartia-brochure-gr-en.pdf?sfvrsn=2dc3db89_78",
      },
      {
        label: "M7 Brochure",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/technical/smartia/m7_end34db9470c47453cb464ae21b7ec7c15.pdf?sfvrsn=c0838c5f_64",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default M7;